// Transformers.js decodes audio file bytes via the Web Audio API's
// `AudioContext`, which is a Window-only API — DedicatedWorkerGlobalScope has
// no `AudioContext`, so handing a transcription Worker a Blob/URL to decode
// itself throws "AudioContext is not available in your environment" on every
// call. Decoding here on the main thread and transferring the resulting
// Float32Array to the worker is the library's own documented workaround for
// worker environments (see transcribeAudio.ts).
const WHISPER_SAMPLE_RATE = 16000;

export async function decodeTo16kMono(blob: Blob): Promise<Float32Array> {
  const arrayBuffer = await blob.arrayBuffer();
  const audioCtx = new AudioContext({ sampleRate: WHISPER_SAMPLE_RATE });
  try {
    const decoded = await audioCtx.decodeAudioData(arrayBuffer);
    if (decoded.numberOfChannels === 2) {
      // Matches Transformers.js's own read_audio downmix (see its utils/audio.js):
      // FFmpeg's -ac 1 scales by 1/sqrt(2) before summing channels to avoid clipping.
      const SCALING_FACTOR = Math.sqrt(2);
      const left = decoded.getChannelData(0);
      const right = decoded.getChannelData(1);
      const audio = new Float32Array(left.length);
      for (let i = 0; i < decoded.length; i++) audio[i] = (SCALING_FACTOR * (left[i] + right[i])) / 2;
      return audio;
    }
    return decoded.getChannelData(0);
  } finally {
    audioCtx.close();
  }
}
